import React from "react";

// Iframe-only Windy weather overlay. The toggle/layer/opacity controls live in
// DashboardPage so they can be grouped with the other map controls.
export default function WindyOverlay({ center, enabled, overlay = "wind", opacity = 70 }) {
  if (!enabled) return null;
  const c = center || { lat: 41.9, lng: 12.5, zoom: 6 };
  const lat = Number(c.lat).toFixed(3);
  const lng = Number(c.lng).toFixed(3);
  const zoom = Math.min(11, Math.round(c.zoom || 6));
  const src =
    `https://embed.windy.com/embed2.html?lat=${lat}&lon=${lng}&detailLat=${lat}&detailLon=${lng}` +
    `&zoom=${zoom}&level=surface&overlay=${overlay}&product=ecmwf&menu=&message=&marker=` +
    `&calendar=now&pressure=&type=map&location=coordinates&metricWind=kt&metricTemp=%C2%B0C&radarRange=-1`;

  return (
    <iframe
      title="Windy meteo"
      data-testid="windy-iframe"
      src={src}
      className="absolute inset-0 w-full h-full border-0"
      style={{ zIndex: 650, opacity: opacity / 100, pointerEvents: "none" }}
    />
  );
}
